import { PaymentTerms } from '../types/client';
import { PaymentTermsDTO } from '../types/dto/payment-terms.dto';

/**
 * Maps ClientStatusDTO (API format) to ClientStatus (domain model)
 */
export const mapClientPaymentTermsFromDTO = (dto: PaymentTermsDTO): PaymentTerms => {
  switch (dto) {
    case PaymentTermsDTO.NET_7:
      return PaymentTerms.Net7;
    case PaymentTermsDTO.NET_15:
      return PaymentTerms.Net15;
    case PaymentTermsDTO.NET_30:
      return PaymentTerms.Net30;
    case PaymentTermsDTO.NET_45:
      return PaymentTerms.Net45;
    case PaymentTermsDTO.NET_60:
      return PaymentTerms.Net60;
    case PaymentTermsDTO.NET_90:
      return PaymentTerms.Net90;
    case PaymentTermsDTO.CIA:
      return PaymentTerms.CashInAdvance;
    case PaymentTermsDTO.COD:
      return PaymentTerms.CashOnDelivery;
    case PaymentTermsDTO.CWO:
      return PaymentTerms.CashWithOrder;
    case PaymentTermsDTO.EOM:
      return PaymentTerms.EndOfMonth;
    default:
      return PaymentTerms.Net30;
  }
};

/**
 * Maps ClientStatus (domain model) to ClientStatusDTO (API format)
 */
export const mapClientPaymentTermsToDTO = (status: PaymentTerms): PaymentTermsDTO => {
  switch (status) {
    case PaymentTerms.Net7:
      return PaymentTermsDTO.NET_7;
    case PaymentTerms.Net15:
      return PaymentTermsDTO.NET_15;
    case PaymentTerms.Net30:
      return PaymentTermsDTO.NET_30;
    case PaymentTerms.Net45:
      return PaymentTermsDTO.NET_45;
    case PaymentTerms.Net60:
      return PaymentTermsDTO.NET_60;
    case PaymentTerms.Net90:
      return PaymentTermsDTO.NET_90;
    case PaymentTerms.CashInAdvance:
      return PaymentTermsDTO.CIA;
    case PaymentTerms.CashOnDelivery:
      return PaymentTermsDTO.COD;
    case PaymentTerms.CashWithOrder:
      return PaymentTermsDTO.CWO;
    case PaymentTerms.EndOfMonth:
      return PaymentTermsDTO.EOM;
    default:
      return PaymentTermsDTO.NET_30;
  }
};
